export function isTesting() {
  try {
    return process.env.JEST_WORKER_ID !== undefined;
  } catch {
    return false;
  }
}
